import { Config } from "./config";
export const BASE_URL = Config.API_URL;

// export const BASE_URL = "http://localhost:5000/v1";
